<template>
  <div>
    <b-modal
      :title="$t('Create Manual Attendance') + ' | ' + attendanceData.date"
      size="lg"
      v-model="show"
      @hidden="$emit('hidden')"
      no-close-on-backdrop
      no-close-on-esc
    >
      <ValidationObserver ref="form-create-manual-attendance">
        <b-row class="my-1">
          <!-- show input if is different of null -->
          <b-col cols="6" v-if="attendanceData.start != null">
            <ValidationProvider
              v-slot="{ errors }"
              name="start_time"
              rules="required"
            >
              <b-form-group
                :label="$t('Start Time')"
                label-for="start_time"
                :state="errors[0] ? false : null"
              >
                <b-form-input v-model="attendanceData.start" :disabled="true" />
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="6" v-else>
            <ValidationProvider
              v-slot="{ errors }"
              name="start_time"
              rules="required"
            >
              <b-form-group
                :label="$t('Start Time')"
                label-for="start_time"
                :state="errors[0] ? false : null"
              >
                <v-select v-model="attendance.start" :options="times" />
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col cols="6">
            <ValidationProvider
              v-slot="{ errors }"
              name="end_time"
              rules="required"
            >
              <b-form-group
                :label="$t('End Time')"
                label-for="end_time"
                :state="errors[0] ? false : null"
              >
                <v-select
                  v-model="attendance.end"
                  :options="times"
                  class="select-outside-modal"
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </ValidationObserver>

      <template #modal-footer>
        <b-button variant="outline-danger" @click="$emit('hidden')">
          {{ $t("Close") }}
        </b-button>

        <b-button
          variant="outline-success"
          @click="createManualAttendance"
          :disabled="attendance.start === null || attendance.end === null"
        >
          {{ $t("Save") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";

export default {
  props: {
    attendanceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      attendance: {
        start: null,
        end: null,
      },
      times: [],
    };
  },
  mounted() {
    this.times = this.generateTimes();
    if (this.attendanceData.start !== null) {
      const index = this.times.findIndex(
        (time) => time === this.attendanceData.start
      );
      this.attendance.start = this.times[index];
    }

    console.log("attendanceData: ", this.attendanceData);
    if(this.attendanceData.end && this.attendanceData.end !== null) {
      const index = this.times.findIndex(
        (time) => time === this.attendanceData.end
      );
      console.log("index: ", index);
      this.attendance.end = this.times[index];
    }
  },
  methods: {
    async createManualAttendance(row) {
      try {
        const confirm = await this.showConfirmSwal();
        if (!confirm.isConfirmed) return;
        this.addPreloader();
        const params = {
          date: this.attendanceData.date,
          personal_id: this.attendanceData.personal_id,
          status: 1,
          origin: 1, // 1: manual
          startTime: this.attendance.start,
          endTime: this.attendance.end,
          alreadyHasStartDate: this.attendanceData.start !== null,
        };
        const { data } = await AttendanceService.createManualAttendance(params);
        this.showToastSuccess(data.message);
        this.$emit("stored");
      } catch (error) {
      } finally {
        this.removePreloader();
      }
    },

    generateTimes() {
      // generate each 5 minutes
      const times = [];
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < 60; j += 5) {
          const hour = i < 10 ? `0${i}` : i;
          const minute = j < 10 ? `0${j}` : j;
          times.push(`${hour}:${minute}`);
        }
      }
      return times;
    },
  },
};
</script>